// extracted by mini-css-extract-plugin
export default {"SpinnerOverlay":"Spinner_SpinnerOverlay__ZO6uL","Spinner":"Spinner_Spinner__s4vpI","spin":"Spinner_spin__UEpE+"};